// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnitDetail_unit-detail__V3myC .ant-tag.ant-tag-has-color {
  color: grey;
}

.UnitDetail_section__x-i5M {
  width: 100%;
  padding: 40px 0;
  background-color: #ffffff;
}
.UnitDetail_section--alt__c3vrc {
  background-color: #f3f7ff;
}
.UnitDetail_section--hero__dVtqM {
  padding: 0;
}

@media only screen and (max-width: 900px) {
  .UnitDetail_section__x-i5M {
    padding: 24px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/UnitDetail/UnitDetail.module.scss"],"names":[],"mappings":"AACE;EACE,WAAA;AAAJ;;AAIA;EACE,WAAA;EACA,eAAA;EACA,yBAAA;AADF;AAGE;EACE,yBAAA;AADJ;AAIE;EACE,UAAA;AAFJ;;AAMA;EACE;IACE,eAAA;EAHF;AACF","sourcesContent":[".unit-detail {\n  :global(.ant-tag.ant-tag-has-color) {\n    color: grey;\n  }\n}\n\n.section {\n  width: 100%;\n  padding: 40px 0;\n  background-color: #ffffff;\n\n  &--alt {\n    background-color: #f3f7ff;\n  }\n\n  &--hero {\n    padding: 0;\n  }\n}\n\n@media only screen and (max-width: 900px) {\n  .section {\n    padding: 24px 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unit-detail": `UnitDetail_unit-detail__V3myC`,
	"section": `UnitDetail_section__x-i5M`,
	"section--alt": `UnitDetail_section--alt__c3vrc`,
	"section--hero": `UnitDetail_section--hero__dVtqM`
};
export default ___CSS_LOADER_EXPORT___;
